import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/onOfficeFields',
        name: 'onOfficeFields',
        meta: { sideMenuLabel: "Campi onOffice", sideMenuIcon: "icon-list" },
        component: () => import("./views/onOfficeFields.vue")
    }
];

export default routes;
